<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <p>{{ body }}</p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="yes()">{{ yesTitle }}</button>
  <button type="button" class="btn btn-secondary" *ngIf="!hideNo" (click)="activeModal.dismiss('No')">No</button>
</div>



// WEBPACK FOOTER //
// ./src/app/shared/prompt-modal/prompt-modal.component.html